import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { Subscription } from 'rxjs';

import { LoaderService } from '@management';

import { Overlay, OverlayRef } from '@angular/cdk/overlay';

import { ComponentPortal } from '@angular/cdk/portal';
import { GlobalLoaderComponent } from '@shared';
import { ErrorHandlerService } from '@services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  public subscription: Subscription = new Subscription();

  public message: string = '';

  public title = 'eh-clientadvisorportal-web';

  overlayRef!: OverlayRef;

  loaderComponentRef!: ComponentRef<GlobalLoaderComponent>;

  constructor(
    public loader: LoaderService,
    private cdr: ChangeDetectorRef,
    private overlay: Overlay,
    private readonly errorHandler: ErrorHandlerService
  ) {}

  ngOnInit(): void {
    this.errorHandler.initErrorHandler();
    this.createOverlay();

    // SHOW / HIDE LOADER
    this.subscription.add(
      this.loader.showLoader$.subscribe((show) => {
        if (show) {
          this.showLoader();
        } else {
          this.hideLoader();
        }
      }),
    );

    // UPDATE MESSAGE
    this.subscription.add(
      this.loader.showWaitingMessage$.subscribe((msg) => {
        this.message = msg;

        // Update dynamically attached component
        if (this.loaderComponentRef) {
          this.loaderComponentRef.instance.message = msg;

          this.loaderComponentRef.changeDetectorRef.detectChanges();
        }
      }),
    );
  }

  createOverlay(): void {
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,

      backdropClass: 'cdk-overlay-dark-backdrop',

      positionStrategy: this.overlay
        .position()
        .global()
        .centerHorizontally()
        .centerVertically(),

      scrollStrategy: this.overlay.scrollStrategies.block(),
    });
  }

  showLoader(): void {
    // Prevent duplicate loader
    if (this.overlayRef.hasAttached()) {
      return;
    }

    const portal = new ComponentPortal(GlobalLoaderComponent);

    this.loaderComponentRef = this.overlayRef.attach(portal);

    // Pass initial message
    this.loaderComponentRef.instance.message = this.message;

    this.loaderComponentRef.changeDetectorRef.detectChanges();
  }

  hideLoader(): void {
    if (this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();

    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
}
